import { weekDaysDataSource } from 'infrastructure/data-sources/week-days';

export function parseContactAvailability(data: string): string {
  try {
    const parsed = JSON.parse(data) as any[];
    const weekDays = weekDaysDataSource();
    let text = '';
    parsed.forEach((el) => {
      text += `\n ${weekDays[el.day]?.name || ''} Start Time: ${
        el.startTime
      } | End Time: ${el.endTime}`;
    });
    return text;
  } catch (error) {
    return data;
  }
}
